import React from 'react';
import "../invoices.css";


class Invoices extends React.Component {

  //List everything we need right at the start.
  //Makes the whole thing a little easier to follow.
  constructor() {
    super();
    this.state = {
      email: global.userData.email,
      name: global.userData.name,
      picture: global.userData.picture,

      domain: 'https://app.bevl.ltd',
      fmAuth: 'Basic RGF0YUFQSUZ1bGxBY2Nlc3M6Q1RuTDJ1eVdie0JEYk1nMjI7OEdUYjNlWUx4QzNY',
      fmFileName: 'Client%20Portal',
      layoutOne: 'Customers',
      layoutTwo: 'Invoices',

      invoices: [],
      contactID: null,
      token: null,
      value: true,
    }
  }


//Start the data grabbing process!
async componentDidMount(){


  //First off, log a session with FileMaker Server and grab a token.
  const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': this.state.fmAuth,
      },
      body: ''
  };
  const url = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/sessions";
  const response = await fetch(url, requestOptions);
  const data = await response.json();
  this.setState({ token: data.response.token });


  //Now we have a token, we use the email address to perform a find in the CUSTOMERS table.
  //This let's us grab the UUID of the CUSTOMER.
  const requestOptionsFindEmail = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.state.token,
    },
    body: '{ "query": [{"d__EmailAddresses": "\\"' + this.state.email + '\\""}]}'
  }
  const urlFindEmail = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/layouts/" + this.state.layoutOne + "/_find";
  await fetch(urlFindEmail, requestOptionsFindEmail)
  .then(responseFindEmail => responseFindEmail.json())
  .then(data => this.setState({ contactID: data.response.data[0].fieldData.PrimaryKey })) ;


  //Now that we have the UUID of the CUSTOMER. Use that to get the list of INVOICES.
  const requestOptionsFindInvoices = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.state.token,
    },
    body: '{ "query": [{"Customer_fk": "' + this.state.contactID + '", "f__IsInClientPortal": "1"}], "sort": [{"fieldName": "d__Date", "sortOrder": "descend"}, {"fieldName": "d__InvoiceID", "sortOrder": "descend"}]}'
  }
  const urlFindInvoices = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/layouts/" + this.state.layoutTwo + "/_find";
  await fetch(urlFindInvoices, requestOptionsFindInvoices)
  .then(responseFindInvoices => responseFindInvoices.json())
  .then(data => this.setState({'invoices': data.response.data}))


  //Finally, we delete the open user session within FileMaker Server (prevents further use of this token)
  const requestOptionsDel = {
    method: 'DELETE',
  };
  const urlDel = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/sessions/" + this.state.token ;
  const responseDel = await fetch(urlDel, requestOptionsDel);
  await responseDel.json();

} //Close the componentDidMount function


//Render the page
render() {
  return (

    <div className="page-section">
    <div className="title-section">
    <h2>
    Invoices
    </h2>
    </div>
    <div className="sub-title-section">
    A list of all your invoices from Bevl Limited for {global.userData.email}.
    </div>


    <div className="main-section" align="left">
    <div className="list-section">
    <table className="invoices-table">

    <tr className="table-test" align="left">
    <th className="table-header" width="60px;"># REF</th>
    <th className="table-header" width="100px;">DATE</th>
    <th className="table-header">DESCRIPTION</th>
    <th className="table-header" width="200px;">STATUS</th>
    <th className="table-header" width="100px;"><div align="right">AMOUNT</div></th>
    </tr>

    {this.state.invoices.map(function(data, recordID) {

      return (
        <tr key="recordID">
          <td className="record-data">{data.fieldData.d__InvoiceID}</td>
          <td className="record-data">{data.fieldData.c__DateFormatted}</td>
          <td className="record-data" style={{paddingRight: 50 + 'px'}}>{data.fieldData.c__DescriptionList}</td>
          <td className="record-data">{data.fieldData.c__Status}</td>
          <td className="pricing" align="right">{data.fieldData.c__InvoiceTotalGross} GBP</td>
        </tr>
        )

      }
    )}

    </table>
      </div>
      </div>
      </div>
  );
}
}

//Export the page using default
export default Invoices;
